<template>
  <div id="customerRecordList">
    <div class="customer_records">
      <div>
        <a-list  itemLayout="vertical" :dataSource="customerRecords" :pagination="listPagination" id="reminderListItems">
          <a-list-item slot="renderItem" slot-scope="item,index">


            <a-list-item-meta v-if='item.recommend == 1'>
              <a-avatar
                icon="user"
                slot="avatar"
                class="userImage"
                :size="40"
                shape="circle"
                :src="getImageUrl(item.createrId)"
              />
              <div slot="title">
                <div class="reminderTitle">
                  <a-row class="follower_header">
                    <div style="font-size: 14px;color: #4D4D4D;font-weight: bold;flex: 1;">{{item.createName}}</div>
                    <div @click="deleteItem(item)" v-if="showEditButtons">
                      <pt-icon type="icon-tubiao" class="edit_icon"></pt-icon>
                    </div>
                  </a-row>
                </div>

                <div class="reminderContentDiv">
                  <a-row class="follower_stage" >
                    <a-row style="display: flex; margin-bottom: 10px;">
                      <div class="follower_type">{{$t('deal.recommend.newRecommend')}}</div>
                      <div style='flex-direction: column;flex: 1'>
                        <div style="flex: 1;text-align: right;">{{item.time | dayjs}}</div>
                      </div>
                    </a-row>

                    <a-row>
                      <div  class='recommend_content'>
                        {{$t('deal.recommend.source')}}：{{item.dealRecommendBuildingVO.buildingName}}/{{item.dealRecommendBuildingVO.type == 1?item.dealRecommendBuildingVO.floorId:item.dealRecommendBuildingVO.floorName}}F/{{item.dealRecommendBuildingVO.unitName}}
                      </div>
                      <div class='recommend_content' style='margin-top: 10px'>
                        {{$t('deal.recommend.newRent')}}：{{$t('deal.recommend.amountUnit')}}{{item.dealRecommendBuildingVO.newRent}}{{$t('deal.recommend.unitArea')}}
                      </div>
                      <div class='recommend_content' style='margin-top: 10px'>
                        {{$t('deal.recommend.freeLeaseTerm')}}：{{item.dealRecommendBuildingVO.freeLeaseTerm}}{{$t('deal.recommend.month')}}
                      </div>
                      <div class='recommend_content' style='margin-top: 10px'>
                        {{$t('deal.recommend.leaseTerm')}}：{{item.dealRecommendBuildingVO.leaseTerm}}{{$t('deal.recommend.month')}}
                      </div>
	                    <div class='recommend_content' style='margin-top: 10px'>
                        {{$t('deal.recommend.startDate')}}：{{item.dealRecommendBuildingVO.startDate}}
                      </div>
                      <div class='recommend_content' style='margin-top: 10px'>
                        {{item.dealRecommendBuildingVO.remarks}}
                      </div>
                    </a-row>
                  </a-row>
                </div>


              </div>




            </a-list-item-meta>



            <a-list-item-meta v-else>
              <a-avatar
                icon="user"
                slot="avatar"
                class="userImage"
                :size="40"
                shape="circle"
                :src="getImageUrl(item.createrId)"
              />
              <div slot="title">
              <div class="reminderTitle">
                <a-row class="follower_header">
                  <div style="font-size: 14px;color: #4D4D4D;font-weight: bold;flex: 1;">{{item.createName}}</div>
                  <div @click="showCustomerRecord(item)" v-show="showEditButtons && userInfo.accountDO.id == item.createrId && item.type != 10">
                    <pt-icon type="icon-bianji1" class="edit_icon"></pt-icon>
                  </div>
                </a-row>
              </div>
              <div class="reminderContentDiv">
                <a-row class="follower_stage" >
                  <a-row style="display: flex; margin-bottom: 10px;">
                    <div class="follower_type">{{$t('deal.dealDetails.customerRecordTypes.' + item.type)}}</div>
                    <div style='flex-direction: column;flex: 1'>
                      <div style="flex: 1;text-align: right;">{{item.time | dayjs}}</div>
                    </div>
                  </a-row>

                  <a-row>
                    <div  style="display: flex;text-align: left;margin-bottom: 5px;" v-if="item.oldRelation != item.newRelation &&  item.oldRelation!= '~' && item.newRelation!= '~' && businessType == '1'">
                      <div  class='relationContent'  >
                        {{ $t('key14guanxibiangengyou') }}
                      </div>
                      <div class='relationText'    >
                        {{item.oldRelationStr}}
                      </div>
                      <div class='relationContent'>
                        {{ $t('key14changewei') }}
                      </div>
                      <div class='relationText'>
                        {{item.newRelationStr}}
                      </div>
                    </div>

                    <!-- 行为变更 -->
                    <div  style="display: flex;text-align: left;margin-bottom: 5px;" v-if="item.oldType!= '0' && item.type!= '~' && businessType == '2' && item.oldType != item.type">
                      <div  class='relationContent'  >
                        {{ $t('key14xingweibiangengyou') }}
                      </div>
                      <div class='relationText'  >
                        {{item.oldTypeStr}}
                      </div>
                      <div class='relationContent'>
                        {{ $t('key14bianwei') }}
                      </div>
                      <div class='relationText' >
                        {{item.typeStr}}
                      </div>
                    </div>

                    <!-- 企业变更 -->
                    <div  style="display: flex;text-align: left;margin-bottom: 5px;" v-if=" businessType =='2' && item.oldRelation!= '~' && item.newRelation!= '~'  && item.oldRelation != item.newRelation">
                      <div  class='relationContent'  >
                        {{ $t('key14qiyeguanxiyou') }}
                      </div>
                      <div class='relationText'>
                        {{item.oldRelationStr}}
                      </div>
                      <div class='relationContent'>
                        {{ $t('key14bianwei') }}
                      </div>
                      <div class='relationText'>
                        {{item.newRelationStr}}
                      </div>
                    </div>
                    <div  style="display: flex;text-align: left;margin-bottom: 5px;" v-if="businessType =='2' && item.oldDemandStatus!= '~' && item.newDemandStatus!= '~' && item.oldDemandStatus!=item.newDemandStatus">
                      <div  class='relationContent'  >
                        {{ $t('key14zhuizongzhuagntaiyou') }}
                      </div>
                      <div class='relationText'>
                        {{item.oldDemandStatusStr}}
                      </div>
                      <div class='relationContent'>
                        {{ $t('key14bianwei') }}
                      </div>
                      <div class='relationText' >
                        {{item.newDemandStatusStr}}
                      </div>
                    </div>
                  </a-row>





                  <div style="display: flex;" v-if="item.employeeDOS">
                    <div style='width: 40px;flex-shrink: 0'> {{$t('deal.dealConfirm.peeUsers')+':'}}</div>
                    <div style="flex:auto">
                      <div style='float: left' v-for="(item1,index) in item.employeeDOS" :key="index" :value="item1.userName">{{item1.userName}}{{index===item.employeeDOS.length-1?"":"、"}}</div>
                    </div>
                  </div>
                  <div v-if="dealDO != null && item.fromProjectStages != item.projectStages">
                    {{$t('deal.dealDetails.dealDetail.stage')}}
                    {{$t('deal.dealDetails.dealDetail.from')}}
                    <span class="dealStages">
                      {{dealDO.dealOriginType == 1 ? $t('deal.dealDetails.leaseProjectStageTypes.' + item.fromProjectStages)
                      : $t('deal.dealDetails.consultantProjectStageTypes.' + item.fromProjectStages)}}
                    </span>
                    {{$t('deal.dealDetails.dealDetail.to')}}
                    <span class="dealStages">
                      {{dealDO.dealOriginType == 1 ? $t('deal.dealDetails.leaseProjectStageTypes.' + item.projectStages)
                      : $t('deal.dealDetails.consultantProjectStageTypes.' + item.projectStages)}}
                    </span>
                  </div>
                  <div v-if="projectVO != null && item.fromProjectStages != item.projectStages">
                    {{$t('deal.dealDetails.dealDetail.stage')}}
                    {{$t('deal.dealDetails.dealDetail.from')}}
                    <span class="dealStages">
                      {{dealStageMap[item.fromProjectStages]}}
                    </span>
                    {{$t('deal.dealDetails.dealDetail.to')}}
                    <span class="dealStages">
                      {{dealStageMap[ item.projectStages]}}
                    </span>
                  </div>
                  <div style="margin: 10px 0 4px 0;width: 304px;" v-if="item.type == 3">{{$t('deal.dealDetails.dealDetail.visit')}}{{item.mansionName}}</div>
                </a-row>
                <a-row>
                  <div style='display: flex'>
                    <pt-icon v-if='item.isSecrecy == 1' style='font-size: 25px' type="icon-baomi1"></pt-icon>

                    <div class="follower_comment">
                      {{item.content}}
                    </div>
                  </div>
                </a-row>

                    <div v-if="item" style="width: 100%">
                      <a-row>
                        <a-col v-for="(item,index1) in initPicture(index)" :key="item.id || item.pictureId || index1" :span="8" :style=" index1 > 2 ? 'margin-top:6px':''">
                          <pt-image :src="getImageUrls(item.pictureId)" fit="cover" :z-index="3000" :isInitialIndex="true"  :preview-src-list="getImageUrlList(initPicture(index))"
                                   class="divImg"></pt-image>
                        </a-col>
                      </a-row>
                    </div>


              </div>
              </div>
            </a-list-item-meta>
          </a-list-item>
        </a-list>
        <!--<a-row v-for="(record,index) in customerRecords" :key="index">-->
          <!--<a-col :span="4">-->
            <!--<div>-->
              <!--<a-avatar-->
                <!--slot="avatar"-->
                <!--shape="circle"-->
                <!--:size="40"-->
                <!--:src="getHeadImg(record.followerImg)"-->
              <!--/>-->
            <!--</div>-->
          <!--</a-col>-->
          <!--<a-col :span="20">-->
            <!--<div>-->
              <!--<a-row class="follower_header">-->
                <!--<a-col :span="12" style="font-size: 14px;color: #4D4D4D;font-weight: bold;">{{record.createName}}</a-col>-->
                <!--<a-col :span="8">{{record.time | dayjs}}</a-col>-->
                <!--<a-col :span="4" @click="showCustomerRecord(record)">-->
                  <!--<pt-icon type="icon-bianji1" class="edit_icon"></pt-icon>-->
                <!--</a-col>-->
              <!--</a-row>-->
              <!--<a-row class="follower_stage">-->
                <!--<div style="display: flex;">-->
                  <!--<div class="follower_type">{{$t('deal.dealDetails.customerRecordTypes.' + record.type)}}</div>-->
                <!--</div>-->
                <!--<div style="margin: 10px 0 4px 0;" v-if="record.type == 3">{{$t('deal.dealDetails.dealDetail.visit')}}{{record.mansionName}}</div>-->
                <!--<div>-->
                  <!--{{$t('deal.dealDetails.dealDetail.stage')}}-->
                  <!--{{$t('deal.dealDetails.dealDetail.from')}}-->
                  <!--{{dealDO.dealOriginType == 1 ? $t('deal.dealDetails.projectStageTypes.' + record.fromProjectStages)-->
                  <!--: $t('deal.dealDetails.consultantProjectStageTypes.' + record.fromProjectStages)}}-->
                  <!--{{$t('deal.dealDetails.dealDetail.to')}}-->
                  <!--{{dealDO.dealOriginType == 1 ? $t('deal.dealDetails.projectStageTypes.' + record.projectStages)-->
                  <!--: $t('deal.dealDetails.consultantProjectStageTypes.' + record.projectStages)}}-->
                <!--</div>-->
              <!--</a-row>-->
              <!--<a-row>-->
                <!--<div class="follower_comment">-->
                  <!--{{record.content}}-->
                <!--</div>-->
              <!--</a-row>-->
            <!--</div>-->
            <!--<a-divider></a-divider>-->
          <!--</a-col>-->
        <!--</a-row>-->
      </div>
    </div>
  </div>
</template>

<script>
  import { getDatadictChildsByPath } from '@/api/sys/datadict'
  import { userMixin } from '@/utils/mixin'
  import Api from "@/api/mine/projects/projects";
 import customerRecordsApi from '@/api/mine/customerRecords'
  export default {
    name: 'customerRecordList',
    props: {
      customerRecords:{
        type:Array,
        default:[]
      },
      datadictChilds:{
        type:Array,
        default:[]
      },

      dealDO:{
        type: Object,
        default:()=>{ return null }
      },
      projectVO:{
        type: Object,
        default:()=>{ return null }
      },
      listPagination:{
        type: Object,
        default:()=>{
          return null
        }
      },
      showEditButtons:{
        type:Boolean,
        default:true,
      },
      businessType:null,
    },
    mixins:[userMixin],
    data() {
      return {
        customerRecordTypes:[],
        dealStages:[],
      }
    },
    computed:{
      dealStageMap(){
        let arr = [];
         this.dealStages.forEach(data=>{
           arr[data.value ] = data.name;
         })
        return arr;
      },
    },
    mounted() {
      this.initProjectStages();
      this.initCustomerRecordTypes()
      console.log('customerRecordTypes',this.customerRecords)
     // this.getRelationsSelects()
    },
    methods: {
      initCustomerRecordTypes() {
        getDatadictChildsByPath('system.business_key.customer_record_type_set').then(res => {
          this.customerRecordTypes = res.data
        })
      },

      initPicture(index){
        let pictureSyc = []
        if(this.customerRecords.length > 0 ){
          if(this.customerRecords[index].pictureSyc != undefined ){
             pictureSyc =  JSON.parse(JSON.stringify(this.customerRecords[index].pictureSyc))
            return pictureSyc
          }else{
            return [];
          }
        }
      },
      initProjectStages(){
        Api.selectProjectStages().then(res=>{
          if(res.code == 1){
            this.dealStages = res.data;
          }
        })
      },

      //显示图片
      getImageUrls(fileId) {
        let url = this.$util.getFileUrl(fileId)
        return url
      },

      //显示图片
      getImageUrlList(fileIds) {
        var arr = [];
        for (let i = 0; i < fileIds.length; i++) {
          let url = this.$util.getFileUrl(fileIds[i].pictureId)
          arr.push(url)
        }
        return arr;
      },

      getImageUrl(userId){
        return this.$util.getHeadImgUrl(userId)
      },
      showCustomerRecord(value){
        this.$emit('showCustomerRecord',value)
      },


      deleteItem(value){
        let _this = this;
        this.$ptConfirm({
          content:'确定删除?',
          onOk(){
            _this.$loading.show();
            customerRecordsApi.deleteRecords({idList:[value.id]}).then(res => {
              if (res.code == 1) {
                _this.$message.success('删除成功')
                _this.$emit('refreshData')
                _this.$loading.hide();
              }
            })
          },
          onCancel(){}
        })
      }

    }
  }
</script>

<style scoped lang="less">
  .customer_records{
    .divImg{
      width: 94px;
      height: 61px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }


    .ant-list-split .ant-list-item{
      border: none;
    }
    .ant-list-split .ant-list-item{
      border-bottom: 0px !important;
    }
    .ant-list-vertical .ant-list-item-meta{
      margin-bottom: 0px !important;
    }
    .ant-list-vertical .ant-list-item-meta-title{
      margin-bottom: 4px !important;
    }
    .reminderContentDiv{
      font-size: 12px;
      color: #333333;
      letter-spacing: 0;
      padding-bottom: 20px;
      border-bottom: 1px solid #E7E7E7;
    }
    .follower_type{
      line-height: 20px;
      height: 25px;
      padding: 1px 11px;
      font-size: 12px;
      color: #95AAC9;
      background: #F9FBFD;
      border: 1px solid #DEE4EC;
    }
    .follower_header{
      height: 40px;
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #999999;
      margin-bottom: 10px;
    }
    .follower_stage{
      font-size: 12px;
      color: #999999;
      margin-bottom: 10px;
    }
    .dealStages{
      font-size: 12px;
      color: #47a1ff;
    }
    .follower_comment{
      width: 304px;
      word-break: break-all;
      font-size: 12px;
      color: #333333;
      letter-spacing: 0;
    }
    .edit_icon{
      font-size: 18px;
      float:right;
      cursor:pointer;
    }
    .relationContent{
      font-size: 12px;
      color: #999999;
      letter-spacing: 0;
      text-align: left;
      line-height: 17px;
      font-weight: 600;
    }

    .recommend_content{
      font-size: 12px;
      color: #000000;
      line-height: 20px;
      font-weight: 600;
    }


    .relationText{
      font-size: 12px;
      color: #188BE3;
      letter-spacing: 0;
      text-align: left;
      line-height: 17px;
      font-weight: 600;
    }
  }
</style>
